import { FlightNotFoundError } from '@/lib/errors/meta/flight-not-found-error'
import { MetaError } from '@/lib/errors/meta/meta-error'

export class MetaCompoundError extends MetaError {
  static from(
    errors: Record<string, unknown>,
    metadata?: Record<string, unknown>,
    message?: string
  ) {
    if (Object.values(errors).every((error) => error instanceof FlightNotFoundError)) {
      return new FlightNotFoundError(metadata, message)
    }
    return new MetaCompoundError(errors, metadata, message)
  }

  errors: Record<string, unknown>

  constructor(
    errors: Record<string, unknown>,
    metadata?: Record<string, unknown>,
    message?: string
  ) {
    super(null, metadata, message)
    this.errors = errors
  }
}
